import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortOn',
  standalone: true
})
export class SortOnPipe implements PipeTransform {

  transform<T>(items: T[], sortData: {sortProperty: string, isAscending: boolean}): T[] {
    return this.sortFn([...items], sortData.sortProperty, sortData.isAscending);
  };

  private sortFn<T>(items: T[], sortProperty: string, directionAscending: boolean): T[] {
    return [...items].sort((a, b) => {
      let att1 = directionAscending ? a : b;
      let att2 = directionAscending ? b : a;
      if (sortProperty === 'deliveryDate') {
          const att1Date = att1[sortProperty] ? new Date(att1[sortProperty])?.getTime() : 0;
          const att2Date = att2[sortProperty] ? new Date(att2[sortProperty])?.getTime() : 0;
          return this.compareData(att1Date, att2Date, directionAscending);
      }
      return this.compareData(att1[sortProperty], att2[sortProperty], directionAscending);
    });
  };

  private compareData(x, y, asc): number {
    if ((x == null && y == null) || x === y) {
        return 0;
    } else if (x == null) {
        return asc ? -1 : 1;
    } else if (y == null) {
        return asc ? 1 : -1;
    }
    return x > y ? 1 : -1;
}

}
